import React, { Component } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { EventSourcePolyfill } from "event-source-polyfill";
import Keycloak from "keycloak-js";
import _ from "lodash";
import { getUser, getUserInfo } from "./services/userServices";
import { getSeries } from "./services/seriesServices";
import NavBar from "./components/navbar";
import Sidebar from "./components/sideBar/sidebar";
import SearchView from "./components/searchView/searchView";
import DisplayView from "./components/display/displayView";
import AnnotationSearch from "./components/annotationSearch";
import AnotateView from "./components/anotateView";
import ProgressView from "./components/progressView";
import FlexView from "./components/flexView";
import NotFound from "./components/notFound";
import LoginForm from "./components/loginForm";
import Logout from "./components/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import Cornerstone from "./components/cornerstone/cornerstone";
import Management from "./components/management/mainMenu";
import InfoMenu from "./components/infoMenu";
import UserMenu from "./components/userProfileMenu.jsx";
import WarningModal from "./components/common/warningModal";
import ConfirmationModal from "./components/common/confirmationModal";
import SelectModalMenu from "./components/common/SelectModalMenu";
// import AnnotationsDock from "./components/annotationsList/annotationDock/annotationsDock";
import auth from "./services/authService";
import MaxViewAlert from "./components/annotationsList/maxViewPortAlert";
import {
  clearAimId,
  getNotificationsData,
  getSingleSerie,
  addToGrid,
  clearGrid,
  clearSelection,
  selectProject,
  getTemplates,
  segUploadCompleted,
  annotationsLoadingError,
  setSeriesData,
  storeAimSelectionAll
} from "./components/annotationsList/action";
import Worklist from "./components/sideBar/sideBarWorklist";
import ErrorBoundary from "./ErrorBoundary";
import Report from "./components/searchView/Report.jsx";
import { getSubjects, getSubject } from "./services/subjectServices";
import {
  decryptAndGrantAccess,
  decryptAndAdd,
} from "./services/decryptUrlService";
import { searchAnnotations } from "./services/annotationServices.js";
import "react-toastify/dist/ReactToastify.css";
// import "./App.css";
import RightsideBar from "./components/RightsideBar/RightsideBar";
import MinimizedReport from "./components/searchView/MinimizedReport";
import { FaJoint } from "react-icons/fa";
import { isSupportedModality } from "./Utils/aid.js";
import { teachingFileTempCode } from './constants';
import SelectSeriesModal from './components/annotationsList/selectSerieModal';

const messages = {
  noPatient: {
    title: "No Patient Selected",
    message: "Select a patient to get a report!",
  },
  multiplePatient: {
    title: "Multiple Patients Selected",
    message: "Select only one patient to get the report!",
  },
  projectWaterfall: {
    title: "Project Selected",
    message: "Waterfall report will be created for project ",
  },
};

const reportsList = [
  { name: "ADLA" },
  { name: "Longitudinal" },
  { name: "RECIST" },
  { name: "Waterfall" },
];
class App extends Component {
  constructor(props) {
    super(props);
    this.eventSource = null;
    this.seriesCallSent = null;
    this.state = {
      openMng: false,
      keycloak: null,
      authenticated: false,
      openInfo: false,
      openUser: false,
      viewType: "list",
      lastEventId: null,
      showLog: false,
      admin: false,
      progressUpdated: 0,
      treeExpand: {},
      expandLevel: 0,
      maxLevel: 0,
      refTree: {},
      // treeData: {},
      pid: null,
      closeAll: 0,
      projectAdded: 0,
      showWarning: false,
      showConfirmation: false,
      showReportsMenu: false,
      title: "",
      message: "",
      reportType: "",
      reportsCompArr: [],
      minReportsArr: [],
      hiddenReports: {},
      metric: null,
      searchQuery: "",
      pairs: {},
      leftMenuState: "open",
      update: 0,
      savedData: {},
      loading: true,
      freeze: "auto",
      teachingLoading: false,
      projectToRole: null,
      username: null,
      showSeries: false,
      openSeriesData: { series: [], studyName: '', worklistID: '' }
    };
  }

  getWorklistPatient = map => {
    const keys = Object.keys(map);
    const pairsSelected = [];
    keys.forEach((item) => {
      const idArr = item.split('-');
      pairsSelected.push({ subjectID: idArr[0], projectID: idArr[1] });
    });
    const pairs = { ...this.state.pairs };
    const index = this.state.reportsCompArr.length;
    pairs[index] = pairsSelected;
    this.setState({ pairs });
  };

  getProjectAdded = () => {
    this.setState((state) => ({
      projectAdded: state.projectAdded + 1,
      refTree: {},
      // treeData: {},
      expandLevel: 0,
      treeExpand: {},
    }));
    localStorage.setItem("treeData", JSON.stringify({}));
  };

  closeWarning = () => {
    this.setState({
      showConfirmation: false,
      showWarning: false,
      title: "",
      message: "",
    });
  };

  handleReportsClick = () => {
    this.setState((state) => ({ showReportsMenu: !state.showReportsMenu }));
  };

  countCurrentReports = (arr) => {
    let nullCount = 0;
    arr.forEach((el) => {
      if (el === null) nullCount++;
    });
    return nullCount;
  };

  closeReportModal = (index) => {
    const arr = [...this.state.reportsCompArr];
    const pairs = { ...this.state.pairs };
    if (this.state.pairs[index]) {
      delete pairs[index];
    }
    arr[index] = null;
    this.setState({
      template: null,
      report: null,
      reportsCompArr: arr,
      pairs,
    });

    // if there isn"t any report open clear selection
    const nullCount = this.countCurrentReports(arr);
    if (nullCount === arr.length) {
      this.props.dispatch(clearSelection());
      if (
        this.props.location.pathname.includes("display")
      ) {
        this.props.history.push(`/display`);
      } else if (this.props.location.pathname.includes("/list/")) {
        const newPid = this.props.location.pathname.split("/").pop();
        this.setState({ pid: newPid });
        this.setState(state => ({
          update: state.update + 1
        }));
      } else {
        this.props.history.push(this.props.location.pathname);
      }
    }
  };

  handleCloseMinimize = (index, reportIndex) => {
    const hiddenReports = { ...this.state.hiddenReports };
    const minReportsArr = [...this.state.minReportsArr];
    const pairs = { ...this.state.pairs };

    if (pairs[reportIndex]) {
      delete pairs[reportIndex];
    }

    minReportsArr[index] = null;
    delete hiddenReports[reportIndex];
    this.setState({
      hiddenReports,
      minReportsArr,
      pairs,
    });

    this.closeReportModal(reportIndex);
  };

  handleMaximizeReport = (e) => {
    let { index, reportindex } = e.target.dataset;
    index = parseInt(index);
    reportindex = parseInt(reportindex);
    const hiddenReports = { ...this.state.hiddenReports };
    const reportsCompArr = [...this.state.reportsCompArr];
    const minReportsArr = [...this.state.minReportsArr];

    minReportsArr[index] = null;
    reportsCompArr[reportindex] = hiddenReports[reportindex];
    delete hiddenReports[reportindex];
    this.setState({
      hiddenReports,
      minReportsArr,
      reportsCompArr,
    });
  };

  handleMinimizeReport = (index, title) => {
    const hiddenReports = { ...this.state.hiddenReports };
    hiddenReports[index] = this.state.reportsCompArr[index];
    const reportsCompArr = [...this.state.reportsCompArr];
    const minReportsArr = [...this.state.minReportsArr];
    const minIndex = minReportsArr.length;
    const component = (
      <MinimizedReport
        index={minIndex}
        reportIndex={index}
        header={title}
        onClose={this.handleCloseMinimize}
        onExpand={this.handleMaximizeReport}
        key={minIndex + "min"}
        count={Object.values(hiddenReports).length}
      />
    );
    reportsCompArr[index] = null;
    minReportsArr.push(component);
    this.setState({ minReportsArr, reportsCompArr, hiddenReports });
  };

  handleReportSelect = (e) => {
    const { projectMap, selectedPatients, openSeries, activePort } = this.props;
    const patients = Object.values(selectedPatients);
    const reportType = e.target.dataset.opt;
    this.handleReportsClick();
    if (patients.length === 0) {
      if (reportType === "Waterfall") {
        if (Object.keys(this.state.pairs).length > 0) {
          this.displayWaterfall();
        } else {
          this.setState({
            showConfirmation: true,
            title: messages.projectWaterfall.title,
            message:
              messages.projectWaterfall.message +
              projectMap[this.state.pid].projectName,
          });
        }
      } else {
        if (openSeries.length > 0) {
          const reportsCompArr = [...this.state.reportsCompArr];
          const index = reportsCompArr.length;
          reportsCompArr.push(
            <Report
              onClose={this.closeReportModal}
              pairs={this.state.pairs}
              report={reportType}
              index={index}
              patient={openSeries[activePort]}
              key={`report${index}`}
              waterfallClickOn={this.handleWaterFallClickOnBar}
              handleMetric={this.getMetric}
              onMinimize={this.handleMinimizeReport}
            />
          );
          this.setState({
            template: null,
            reportType,
            reportsCompArr,
          });
        } else {
          this.setState({
            showWarning: true,
            title: messages.noPatient.title,
            message: messages.noPatient.message,
          });
        }
      }
    } else if (patients.length > 1 && reportType !== "Waterfall") {
      this.setState({
        showWarning: true,
        title: messages.multiplePatient.title,
        message: messages.multiplePatient.message,
      });
    } else {
      const reportsCompArr = [...this.state.reportsCompArr];
      const index = reportsCompArr.length;
      reportsCompArr.push(
        <Report
          onClose={this.closeReportModal}
          report={reportType}
          index={index}
          patient={patients[0]}
          key={`report${index}`}
          pairs={this.state.pairs}
          waterfallClickOn={this.handleWaterFallClickOnBar}
          handleMetric={this.getMetric}
          onMinimize={this.handleMinimizeReport}
        />
      );
      this.setState({
        template: null,
        reportType,
        reportsCompArr,
      });
    }
  };

  getMetric = (metric) => {
    this.setState({ metric });
  };
  handleWaterFallClickOnBar = async (name) => {
    // find the patient selected
    // if project selected get patient details with call
    const { selectedProject, selectedPatients } = this.props;
    let patient;
    if (selectedProject) {
      ({ data: patient } = await getSubject(selectedProject, name));
      if (!patient.patientID) patient.patientID = patient.subjectID;
    } else {
      patient = this.props.selectedPatients[name];
    }

    const reportsCompArr = [...this.state.reportsCompArr];
    const index = reportsCompArr.length;
    reportsCompArr.push(
      <Report
        onClose={this.closeReportModal}
        report={this.state.metric}
        index={index}
        patient={patient}
        pairs={this.state.pairs}
        key={`report${index}`}
        waterfallClickOn={this.handleWaterFallClickOnBar}
        handleMetric={this.getMetric}
        onMinimize={this.handleMinimizeReport}
      />
    );
    this.setState({
      reportsCompArr,
    });
  };

  displayWaterfall = () => {
    this.props.dispatch(selectProject(this.state.pid));
    const reportsCompArr = [...this.state.reportsCompArr];
    const index = reportsCompArr.length;
    reportsCompArr.push(
      <Report
        onClose={this.closeReportModal}
        report={"Waterfall"}
        index={index}
        pairs={this.state.pairs}
        // patient={patients[0]}
        key={`report${index}`}
        waterfallClickOn={this.handleWaterFallClickOnBar}
        handleMetric={this.getMetric}
        onMinimize={this.handleMinimizeReport}
      />
    );

    this.setState({
      template: null,
      reportType: "Waterfall",
      showConfirmation: false,
      reportsCompArr,
    });
  };

  collapseSubjects = () => {
    const { treeExpand, expandLevel } = this.state;
    if (Object.keys(treeExpand).length > 0 && expandLevel > 0)
      this.setState({ treeExpand: {}, expandLevel: 0 });
    else if (Object.keys(treeExpand).length > 0)
      this.setState({ treeExpand: {} });
    else if (expandLevel > 0) this.setState({ expandLevel: 0 });
    else return;
  };

  getTreeExpandAll = (expandObj, expanded, expandLevel) => {
    try {
      const { patient, study, series } = expandObj;
      let treeExpand = { ...this.state.treeExpand };
      let refPatients, refStudies, subSeries, subStudies;
      const patientLevel = study === undefined && series === undefined;
      const studyLevel = series === undefined && study !== undefined;
      const seriesLevel =
        patient !== undefined && study !== undefined && series !== undefined;
      if (patientLevel) {
        if (expanded) {
          for (let i = 0; i < patient; i += 1) treeExpand[i] = {};
          if (expandLevel >= this.state.maxLevel)
            this.setState({ maxLevel: expandLevel, refTree: treeExpand });
        }
        if (!expanded) {
          for (let i = 0; i < patient; i += 1) {
            treeExpand[i] = false;
          }
        }
      }

      if (studyLevel) {
        refPatients = Object.values(this.state.refTree);
        for (let i = 0; i < refPatients.length; i += 1) {
          if (!treeExpand[i]) treeExpand[i] = {};
        }
        if (expanded) {
          for (let i = 0; i < study; i += 1) {
            treeExpand[patient][i] = {};
          }
          if (expandLevel >= this.state.maxLevel)
            this.setState({ maxLevel: expandLevel, refTree: treeExpand });
        }
        if (!expanded) {
          for (let i = 0; i < study; i += 1) {
            treeExpand[patient][i] = false;
          }
        }
      }

      if (seriesLevel) {
        refPatients = Object.values(this.state.refTree);
        for (let i = 0; i < refPatients.length; i += 1) {
          refStudies = Object.values(refPatients[i]);
          if (!treeExpand[i]) {
            treeExpand[i] = {};
          }
          for (let k = 0; k < refStudies.length; k++) {
            treeExpand[i][k] = {};
          }
        }
        if (expanded) {
          for (let i = 0; i < series; i += 1) {
            treeExpand[patient][study][i] = {};
          }
          if (expandLevel >= this.state.maxLevel)
            this.setState({ maxLevel: expandLevel, refTree: treeExpand });
        }
        if (!expanded) {
          for (let i = 0; i < study; i += 1) {
            treeExpand[patient][study][i] = false;
          }
        }
      }
      this.setState({ treeExpand });
    } catch (err) {
      console.error(err);
    }
  };

  closeBeforeDelete = (level, ids) => {
    return new Promise((resolve, reject) => {
      try {
        const treeExpand = { ...this.state.treeExpand };
        if (level === "patientID") {
          treeExpand[ids.index] = false;
        }
        this.setState({ treeExpand });
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  };

  getTreeExpandSingle = async (expandObj) => {
    try {
      const { patient, study, series } = expandObj;
      let treeExpand = { ...this.state.treeExpand };
      let index, val;
      const patientLevel = patient && !study && !series;
      const studyLevel = study && !series;
      const seriesLevel = series;

      if (patientLevel) {
        index = Object.keys(patient);
        index = index[0];
        val = Object.values(patient);
        val = val[0];
        treeExpand[index] = val;
      }
      if (studyLevel) {
        index = Object.keys(study);
        index = index[0];

        val = Object.values(study);
        val = val[0];
        treeExpand[patient][index] = val;
      }
      if (seriesLevel) {
        index = Object.keys(series);
        index = index[0];

        val = Object.values(series);
        val = val[0];
        treeExpand[patient][study][index] = val;
      }
      this.setState({ treeExpand });
    } catch (err) {
      console.error(err);
    }
  };

  getExpandLevel = (expandLevel) => {
    this.setState({ expandLevel });
  };

  handleShrink = async () => {
    const { expandLevel } = this.state;
    if (expandLevel > 0) {
      await this.setState((state) => ({ expandLevel: state.expandLevel - 1 }));
    }
  };

  closeMenu = (notification) => {
    // if (event && event.type === "keydown") {
    //   if (event.key === "Escape" || event.keyCode === 27) {
    //     this.setState({ openMng: false });
    //   }
    // }
    this.setState({
      openMng: false,
      openInfo: false,
      openUser: false,
      openMenu: false,
    });
    if (notification) this.updateNotificationSeen();
  };

  switchView = (viewType, force) => {
    window.dispatchEvent(new CustomEvent("unfuse"));

    this.props.dispatch(clearSelection());
    this.props.dispatch(storeAimSelectionAll(null, null, null, true));

    const { pid } = this.state;
    this.setState({ viewType });
    const { openSeries } = this.props;
    const portOpen = openSeries.length > 0;
    if (viewType === "list") {
      // this.props.dispatch(clearSelection());
      if (!portOpen || force) {
        pid
          ? this.props.history.push(`/list/${pid}`)
          : this.props.history.push(`/list`);
      }
    } else if (viewType === "display") {
      if (this.props.openSeries.length)
        this.props.history.push(`/display`);
      else {
        toast.info("There is no open series to display", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } else if (viewType === "search") {
      pid
        ? this.props.history.push(`/search/${pid}`)
        : this.props.history.push(`/search`);
    } else if (viewType === "flex") {
      pid
        ? this.props.history.push(`/flex/${pid}`)
        : this.props.history.push(`/flex`);
    }
  };

  handleMngMenu = () => {
    this.setState((state) => ({
      openInfo: false,
      openMng: !state.openMng,
      openUser: false,
    }));
  };

  handleInfoMenu = () => {
    this.setState((state) => ({
      openInfo: !state.openInfo,
      openMng: false,
      openUser: false,
    }));
  };

  handleUserProfileMenu = () => {
    this.setState((state) => ({
      openInfo: false,
      openMng: false,
      openUser: !state.openUser,
    }));
  };

  updateProgress = () => {
    this.setState((state) => ({ progressUpdated: state.progressUpdated + 1 }));
  };

  async componentDidMount() {
    localStorage.setItem("treeData", JSON.stringify({}));
    sessionStorage.removeItem("searchState");
    Promise.all([
      fetch(`${process.env.PUBLIC_URL}/config.json`),
      fetch(`${process.env.PUBLIC_URL}/keycloak.json`),
    ])
      .then(async (results) => {
        const configData = await results[0].json();

        let { mode, apiUrl, wadoUrl, authMode, maxPort, defaultAimName, feedback } =
          configData;
        // check and use environment variables if any
        const authServerUrl =
          process.env.REACT_APP_AUTH_URL || Keycloak["auth-server-url"];
        mode = process.env.REACT_APP_MODE || mode;
        apiUrl = process.env.REACT_APP_API_URL || apiUrl;
        wadoUrl = process.env.REACT_APP_WADO_URL || wadoUrl;
        authMode = process.env.REACT_APP_AUTH_MODE || authMode;
        const waterfallOptions = process.env.REACT_APP_WATERFALL_OPTS;
        maxPort = process.env.REACT_APP_MAX_PORT || maxPort || 6;
        defaultAimName =
          process.env.REACT_APP_DEFAULT_AIM_NAME || defaultAimName;
        feedback =
          process.env.REACT_APP_FEEDBACK || feedback;
        const legacyReporting = (process.env.REACT_APP_LEGACY_REPORTING && process.env.REACT_APP_LEGACY_REPORTING === "true") || false;
        sessionStorage.setItem("mode", mode);
        sessionStorage.setItem("apiUrl", apiUrl);
        sessionStorage.setItem("wadoUrl", wadoUrl);
        sessionStorage.setItem("authMode", authMode);
        sessionStorage.setItem("maxPort", maxPort);
        sessionStorage.setItem("defaultAimName", defaultAimName);
        sessionStorage.setItem("feedback", feedback);
        sessionStorage.setItem("legacyReporting", legacyReporting);

        if (waterfallOptions) {
          sessionStorage.setItem("waterfallOptions", waterfallOptions);
        }

        if (mode === 'teaching') {
          document.title = "Stella";
          document.getElementById("favicon");
          favicon.href = "/stella.png"
          this.setState({ viewType: 'search' })
        }

        this.setState({ mode, apiUrl, wadoUrl, authMode });
        const keycloakData = await results[1].json();
        const auth =
          process.env.REACT_APP_AUTH_URL || keycloakData["auth-server-url"];
        const keycloakJson = {};
        // check and use environment variables if any
        keycloakJson.realm =
          process.env.REACT_APP_AUTH_REALM || keycloakData.realm;
        keycloakJson.url =
          process.env.REACT_APP_AUTH_URL || keycloakData["auth-server-url"];
        keycloakJson.clientId =
          process.env.REACT_APP_AUTH_RESOURCE || keycloakData.resource;
        // added for teaching SSO connection. required for PHI
        // SSO requires PKCE
        const pkce = process.env.REACT_APP_PKCE || keycloakData.pkce;
        if (pkce) sessionStorage.setItem("pkce", pkce);
        const checkSso = process.env.REACT_APP_SSO || keycloakData.sso;
        if (checkSso) sessionStorage.setItem("sso", checkSso);
        // ---
        sessionStorage.setItem("auth", auth);
        sessionStorage.setItem("keycloakJson", JSON.stringify(keycloakJson));
        if (mode === "lite") this.setState({ pid: "lite" });
        const args = this.getArguments();
        args ? this.handleArgs(args) : this.completeAutorization(apiUrl, args);
      })
      .catch((err) => {
        console.error(err);
      });
    //get notifications from sessionStorage and setState
    let notifications = sessionStorage.getItem("notifications");
    if (!notifications) {
      sessionStorage.setItem("notifications", JSON.stringify([]));
      this.setState({ notifications: [] });
    } else {
      notifications = JSON.parse(notifications);
      this.setState({ notifications });
    }
  }

  componentDidUpdate = (prevProps) => {
    const uploaded = this.props.notificationAction.startsWith("Upload");
    const deleted = this.props.notificationAction.startsWith("Delete");
    if (
      prevProps.lastEventId !== this.props.lastEventId &&
      (uploaded || deleted)
    ) {
      this.props.dispatch(getTemplates());
      localStorage.setItem("treeData", JSON.stringify({}));
      this.clearTreeExpand();
      this.setState(state => ({
        update: state.update + 1
      }));
    }
    const oldPid = prevProps.location.pathname.split("/").pop();
    const newPid = this.props.location.pathname.split("/").pop();
    const route = this.props.location.pathname.split("/")[1];

    if (oldPid !== newPid && route === "list") {
      this.setState({ pid: newPid });
    }
  };

  componentWillUnmount = () => {
    this.eventSource.removeEventListener(
      "message",
      this.getMessageFromEventSrc
    );
    localStorage.setItem("treeData", JSON.stringify({}));
    this.clearSessionStorageItems();
  };

  clearSessionStorageItems = () => {
    sessionStorage.removeItem("authMode");
    sessionStorage.removeItem("API_KEY");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("username");
  };

  getArguments = () => {
    const { search } = this.props.location;
    let args = sessionStorage.getItem("args");
    if (search && !args) args = search.split("?arg=")[1];
    return args;
  };

  handleArgs = async (args) => {
    this.setState({ loading: true, freeze: 'none', teachingLoading: true });
    const { data } = await decryptAndGrantAccess(args);
    const { API_KEY, seriesArray, user, patientID, studyUID, projectID } = data;
    const { openSeries } = this.props;

    this.setState({ pid: projectID })

    if (API_KEY && user) {
      // THIS IS APIKEY
      sessionStorage.setItem("authMode", "apiKey");
      sessionStorage.setItem("API_KEY", API_KEY);
      sessionStorage.setItem("username", user);
      sessionStorage.setItem("displayName", user);
      sessionStorage.setItem("encrypted", "true");
    }

    await this.completeAutorization();

    if (seriesArray) {
      this.setState({ loading: true, freeze: 'none' })
      const parsedSeriesArray = JSON.parse(seriesArray);
      parsedSeriesArray.forEach(
        (serie, i) => (parsedSeriesArray[i] = { ...serie, projectID })
      );
      if (!this.hasEnoughViewports(parsedSeriesArray)) {
        const maxPort = parseInt(sessionStorage.getItem("maxPort"));
        alert(
          `Number of series passed is more than allowable number of port. Max allowed is ${maxPort}. Please select the series you want to display`
        );
        return;
      }
      const promiseArr = [];
      for (let serie of parsedSeriesArray) {
        serie.projectID = serie.projectID || 'lite';
        this.props.dispatch(addToGrid(serie));
        promiseArr.push(this.props.dispatch(getSingleSerie(serie)));
      }
      Promise.all(promiseArr)
        .then(() => {
          this.setState({ loading: false, freeze: 'auto' })
          this.props.history.push("/display");
        })
        .catch((err) => console.error(err));
    } else if (patientID && studyUID && projectID) {
      // This should be teaching files
      this.setState({ loading: true, freeze: 'none' })
      const packedData = {
        projectID,
        patientID,
        patientName: "patientName",
        studyUID,
      };
      // If study has teaching file it's already added so no need to add
      const { data: TF } = await this.hasTeachingFiles(studyUID);
      if (TF.total_rows) {
        this.displaySeries(packedData);
      } else {
        const seriesArray = await this.getSeriesData(packedData, 'handle args');
        window.dispatchEvent(
          new CustomEvent("openTeachingFilesModal", {
            detail: { seriesArray, args, packedData },
          })
        );
      }
    }
  };


  hasTeachingFiles = (studyUID) => {
    return searchAnnotations({
      query: `(template_code:${teachingFileTempCode} AND study_uid:${studyUID}) AND project:lite`,
    });
  };

  displaySeries = async (studyData, worklistID) => {
    const rawSeriesArray = await this.getSeriesData(studyData);
    if (!rawSeriesArray) return;
    let seriesArr = rawSeriesArray.filter(isSupportedModality);
    let significantSeries = seriesArr.filter(
      ({ significanceOrder }) => significanceOrder && significanceOrder > 0
    );
    // If there are significant series use them to display
    // if not display modality filtered series
    if (significantSeries.length && !worklistID) seriesArr = significantSeries;
    //if check if there is enough available viewports
    if (!this.hasEnoughViewports(seriesArr) && !worklistID) return;
    //add serie to the grid
    const promiseArr = [];
    if (worklistID) this.props.dispatch(clearGrid());
    for (let serie of seriesArr) {
      // optional clear grid
      // if (worklistID) this.props.dispatch(clearGrid());
      this.props.dispatch(addToGrid(serie, null, null, worklistID));
      promiseArr.push(this.props.dispatch(getSingleSerie(serie)));
    }
    Promise.all(promiseArr)
      .then(() => {
        this.setState({ loading: false, freeze: 'auto' })
        this.props.history.push("/display");
      })
      .catch((err) => console.error(err));
  };

  hasEnoughViewports = (seriesArr) => {
    const maxPort = parseInt(sessionStorage.getItem("maxPort"));
    if (!maxPort) {
      alert("Maximum allowable viewport number is not defined!");
      return false;
    }
    if (seriesArr.length + this.props.openSeries.length > maxPort) {
      window.dispatchEvent(
        new CustomEvent("openSeriesModal", {
          detail: seriesArr,
        })
      );
      return false;
    }
    return true;
  };

  getSeriesData = async (studyData, src) => {
    console.log(' ---> getSeriesData', src);
    const { projectID, studyUID } = studyData;
    const { seriesData } = this.props;
    let { patientID, subjectID } = studyData;
    patientID = patientID || subjectID;
    let series;
    const mode = this.state.mode ? this.state.mode : sessionStorage.getItem("mode");
    try {
      const dataExists = seriesData[projectID] &&
        seriesData[projectID][patientID] &&
        seriesData[projectID][patientID][studyUID] &&
        seriesData[projectID][patientID][studyUID].list;
      if (!dataExists && this.seriesCallSent !== studyUID) {
        ({ data: series } = await getSeries(projectID, patientID, studyUID, false, "App.js, getSeriesData"));
        if (series && series.length === 0 && mode === "teaching") ({ data: series } = await getSeries(projectID, patientID, studyUID, true, "App.js, getSeriesData"));
        this.seriesCallSent = studyUID;
        this.props.dispatch(setSeriesData(projectID, patientID, studyUID, series, true));
        this.setState({ teachingLoading: false });
        return series;
      } else return seriesData[projectID]?.[patientID]?.[studyUID]?.list;
    } catch (err) {
      console.error(err);
      this.props.dispatch(annotationsLoadingError(err));
    }
  };

  // This is func is serious mess, needs refactoring
  completeAutorization = () =>
    new Promise((resolve, reject) => {
      let getAuthUser = null;
      const authMode = sessionStorage.getItem("authMode");
      const apiUrl = sessionStorage.getItem("apiUrl");

      if (authMode === "apiKey") {
        const username = sessionStorage.getItem("username");
        getAuthUser = new Promise((resolve) => {
          resolve({
            userInfo: { preferred_username: username },
            keycloak: null,
            authenticated: true,
          });
        }).catch((err) => reject(err));
      } else if (authMode !== "external") {
        const keycloak = Keycloak(
          JSON.parse(sessionStorage.getItem("keycloakJson"))
        );
        const pkce = sessionStorage.getItem("pkce");
        const sso = sessionStorage.getItem("sso");
        getAuthUser = new Promise((resolve, reject) => {
          if (sso && sso === 'true') {
            keycloak
              .init({ onLoad: "check-sso", checkLoginIframeInterval: 1, ...(pkce && pkce === "true" ? { pkceMethod: 'S256' } : {}) })
              .then((authenticated) => {
                if (authenticated)
                  keycloak
                    .loadUserInfo()
                    .then((userInfo) => {
                      resolve({ userInfo, keycloak, authenticated });
                    })
                    .catch((err) => reject(err));
                else
                  keycloak.login();
              })
              .catch((err) => reject(err));
          }
          else {
            keycloak
              .init({ onLoad: "login-required" })
              .then((authenticated) => {
                if (authenticated)
                  keycloak
                    .loadUserInfo()
                    .then((userInfo) => {
                      resolve({ userInfo, keycloak, authenticated });
                    })
                    .catch((err) => reject(err));
              })
              .catch((err) => reject(err));
          }
        });
      } else {
        // authMode is external ask backend for user
        getAuthUser = new Promise((resolve, reject) => {
          getUserInfo()
            .then((userInfoResponse) => {
              resolve({
                userInfo: userInfoResponse.data,
                keycloak: null,
                authenticated: true,
              });
            })
            .catch((err) => reject(err));
        });
      }
      getAuthUser
        .then(async (result) => {
          try {
            const username =
              result.userInfo.preferred_username || result.userInfo.uid || result.userInfo.email;

            await auth.setLoginKeycloak(result.keycloak);
            let userData;
            try {
              userData = await getUser(username);
              // check if userData exists if not alert and logout
              // if teaching "User doesn't exist, you should login from Sectra first."
              // "User doesn't exist, contact your administrator."
              userData = userData.data;
              this.setState({ admin: userData.admin, projectToRole: userData.projectToRole, username: userData.username });
            } catch (err) {
              // console.log("Error in catch", err);
              // // if(err.statusCode === 401){
              //   if(this.state.mode==="teaching")
              //     alert("User doesn't exist, you should login from Sectra first.");
              //   else
              //     alert("User doesn't exist, contact your administrator.");
              //   this.onLogout();
              // // }
              // console.error(err);
            }
            let displayname = userData.firstname.concat(' ', userData.lastname);
            let user = {
              user: userData.username,
              displayname
            };
            await auth.setLoginSession(user, null);
            this.setState({
              keycloak: result.keycloak,
              authenticated: result.authenticated,
              id: result.userInfo.sub,
              user,
            });

            if (authMode === "apiKey") {
              const API_KEY = sessionStorage.getItem("API_KEY");
              const user = sessionStorage.getItem("username");
              this.eventSource = new EventSourcePolyfill(
                `${apiUrl}/notifications?user=${user}`,
                {
                  headers: {
                    authorization: `apikey ${API_KEY}`,
                  },
                }
              );
            } else {
              this.eventSource = new EventSourcePolyfill(
                `${apiUrl}/notifications`,
                result.keycloak.token
                  ? {
                    headers: {
                      authorization: `Bearer ${result.keycloak.token}`,
                    },
                  }
                  : {}
              );
            }

            this.eventSource.addEventListener(
              "message",
              this.getMessageFromEventSrc
            );
            resolve();
          } catch (err) {
            // console.error(err);
            // // reject("Error in user retrieval 2!", err);
            //   // if(err.statusCode === 401){
            //     if(this.state.mode==="teaching")
            //       alert("User doesn't exist, you should login from Sectra first.");
            //     else
            //       alert("User doesn't exist, contact your administrator.");
            //     this.onLogout();
            //   // }
            console.error(err);
            // this.completeAutorization();
          }
        })
        .catch((err2) => {
          console.log("Err 2", err2);
          // reject("Authentication failed!", err2);
        });
    });

  getMessageFromEventSrc = (res) => {
    try {
      if (res.data === "heartbeat") {
        return;
      }
      const parsedRes = JSON.parse(res.data);
      const { lastEventId } = res;
      const { params, createdtime, projectID, error, refresh } =
        parsedRes.notification;
      const action = parsedRes.notification.function;
      const message = params;
      // check if the notification is for successfull upload segmentation
      this.checkIfSegUpload(params);
      if (refresh)
        this.props.dispatch(
          getNotificationsData(projectID, lastEventId, refresh, action)
        );
      let time = new Date(createdtime).toString();
      const GMTIndex = time.indexOf(" G");
      time = time.substring(0, GMTIndex - 3);
      let notifications = [...this.state.notifications];
      notifications.unshift({
        message,
        time,
        seen: false,
        action,
        error,
      });
      const tagEdited = action.startsWith("Tag");
      const uploaded = action.startsWith("Upload");
      if (tagEdited || uploaded) {
        const { pid } = this.state;
        // this.setState({ treeData: {} });
        localStorage.setItem("treeData", JSON.stringify({}));
        this.setState({ pid });
        // if (this.props.openSeries.length === 0) {
        //   this.props.history.push(`/list/${pid}`);
        // }
      }
      this.setState({ notifications });
      const stringified = JSON.stringify(notifications);
      sessionStorage.setItem("notifications", stringified);
    } catch (err) {
      console.error(err);
    }
  };

  onLogout = (e) => {
    auth.logout();
    // sessionStorage.removeItem("annotations");
    sessionStorage.setItem("notifications", JSON.stringify([]));
    this.setState({
      authenticated: false,
      id: null,
      name: null,
      user: null,
    });

    if (sessionStorage.getItem("authMode") !== "external")
      this.state.keycloak.logout().then(() => {
        this.setState({
          keycloak: null,
        });
        auth.logout();
      });
    else console.log("No logout in external authentication mode");
  };

  updateNotificationSeen = () => {
    const notifications = [...this.state.notifications];
    notifications.forEach((notification) => {
      notification.seen = true;
    });
    this.setState({ notifications });
    const stringified = JSON.stringify(notifications);
    sessionStorage.setItem("notifications", stringified);
  };

  switchSearhView = () => {
    this.props.dispatch(clearAimId());
  };

  handleCloseAll = () => {
    // let { closeAll } = this.state;
    // closeAll += 1;
    this.setState((state) => ({
      expandLevel: 0,
      closeAll: state.closeAll + 1,
    }));
  };

  getTreeData = (projectID, level, data) => {
    try {
      let treeData = JSON.parse(localStorage.getItem("treeData"));
      // const treeData = { ...this.state.treeData };
      const patientIDs = [];
      if (level === "subject") {
        if (!treeData[projectID]) treeData[projectID] = {};
        data.forEach((el) => {
          if (!treeData[projectID][el.subjectID]) {
            treeData[projectID][el.subjectID] = { data: el, studies: {} };
          }
          patientIDs.push(el.subjectID);
        });
        if (treeData[projectID]) {
          if (data.length < Object.keys(treeData[projectID]).length) {
            for (let patient in treeData[projectID]) {
              if (!patientIDs.includes(patient)) {
                delete treeData[projectID][patient];
              }
            }
          }
        }
      } else if (level === "studies") {
        const studyUIDs = [];
        const patientID = data[0].patientID;
        data.forEach((el) => {
          if (!treeData[projectID][el.patientID].studies[el.studyUID]) {
            treeData[projectID][el.patientID].studies[el.studyUID] = {
              data: el,
              series: {},
            };
          }
          studyUIDs.push(el.studyUID);
        });
        const studiesObj = treeData[projectID][patientID].studies;
        const studiesArr = Object.values(studiesObj);
        if (data.length < studiesArr.length) {
          for (let study in studiesObj) {
            if (!studyUIDs.includes(study)) {
              delete studiesObj[study];
            }
          }
        }
      } else if (level === "series") {
        const patientID = data[0].patientID;
        const studyUID = data[0].studyUID;
        const seriesUIDs = [];
        data.forEach((el) => {
          if (
            !treeData[projectID][el.patientID].studies[el.studyUID].series[
            el.seriesUID
            ]
          ) {
            treeData[projectID][el.patientID].studies[el.studyUID].series[
              el.seriesUID
            ] = {
              data: el,
            };
          }
          seriesUIDs.push(el.seriesUID);
        });
        const seriesObj =
          treeData[projectID][patientID].studies[studyUID].series;
        const seriesArr = Object.values(seriesObj);
        if (data.length < seriesArr.length) {
          for (let series in seriesObj) {
            if (!seriesUIDs.includes(series)) {
              delete seriesObj[series];
            }
          }
        }
      }
      // this.setState({ treeData });
      localStorage.setItem("treeData", JSON.stringify(treeData));
    } catch (err) {
      console.error(err);
    }
  };

  getPidUpdate = (pid) => {
    this.setState({ searchQuery: "" });
    this.setState({ pid });
  };

  openProject = (pid, route) => {
    this.getPidUpdate(pid);
    this.props.history.push(route)
  }

  clearTreeExpand = () => {
    this.setState({ treeExpand: {}, expandLevel: 0 });
  };

  sortLevelArr = (arr, attribute) => {
    return arr.sort(function (a, b) {
      if (a.data[attribute] < b.data[attribute]) {
        return -1;
      }
      if (a.data[attribute] > b.data[attribute]) {
        return 1;
      }
      return 0;
    });
  };

  getPatientIDfromSortedArray = (index, arr, attribute, returnVal) => {
    const sortedArr = this.sortLevelArr(arr, attribute);
    return sortedArr[index].data[returnVal];
  };

  getIndexOfPatient = (arr, patientID) => {
    let index;
    arr.forEach((el, i) => {
      if (el.data.subjectID === patientID) {
        index = i;
      }
    });
    return index;
  };

  clearAllTreeData = () => {
    // this.setState({ treeData: {} });
    localStorage.setItem("treeData", JSON.stringify({}));
  };

  clearTreeData = () => {
    try {
      const { pid, treeExpand } = this.state;
      let treeData = JSON.parse(localStorage.getItem("treeData"))[pid];
      const patients = treeData[pid];
      const patientsArr = Object.values(patients);
      for (let patientIndex in treeExpand) {
        // if the index is kept as false it means that
        // level opened and then closed so we need to clear data
        const patientID = this.getPatientIDfromSortedArray(
          patientIndex,
          patientsArr,
          "subjectName",
          "subjectID"
        );
        if (!treeExpand[patientIndex]) {
          // find subject id and empty studies
          patients[patientID].studies = {};
        } else {
          for (let studyIndex in treeExpand[patientIndex]) {
            if (!treeExpand[patientIndex][studyIndex]) {
              const studies = Object.values(patients[patientID].studies);
              const { studyUID } = studies[studyIndex].data;
              patients[patientID].studies[studyUID].series = {};
            }
          }
        }
      }
      treeData[pid] = patients;
      // this.setState({ treeData });
      localStorage.setItem("treeData", JSON.stringify(treeData));
    } catch (err) {
      console.error(err);
    }
  };

  findNonExisting = (arr, uid, level) => {
    const result = arr.filter((el) => el[level] === uid);
    return result[0];
  };

  checkIfSegUpload = (params) => {
    const { isSegUploaded } = this.props;
    const segsUploaded = Object.keys(isSegUploaded);
    for (let i = 0; i < segsUploaded.length; i++) {
      if (params.includes(segsUploaded[i])) {
        return this.props.dispatch(segUploadCompleted(segsUploaded[i]));
      }
    }
  };

  updateTreeDataOnSave = async (refs, newLevel) => {
    try {
      // this.setState({ treeData: {} });
      localStorage.setItem("treeData", JSON.stringify({}));
      this.clearTreeExpand();
    } catch (err) {
      console.error(err);
    }
  };

  closeLeftMenu = () => {
    console.log("setting", this.state.leftMenuState);
    this.setState({ leftMenuState: "closed" });
  }

  displayNextStudy = async (study, worklist) => {
    const { studyDescription } = study;
    let series = await this.getSeriesData(study, 'display next study');
    const maxPort = parseInt(sessionStorage.getItem("maxPort"));
    if (series.length <= maxPort) {
      // viewSelection(series);
      // add - 1 logic if there is a worklist
      this.displaySeries(study, worklist);
    } else {
      const openSeriesData = { series, studyName: studyDescription, worklistID: worklist }
      this.setState({ showSeries: true, openSeriesData })
    }
    // setSeries(series);
  }


  render() {
    const {
      notifications,
      mode,
      progressUpdated,
      treeExpand,
      showReportsMenu,
      showWarning,
      showConfirmation,
      title,
      message,
    } = this.state;
    let noOfUnseen;
    if (notifications) {
      noOfUnseen = notifications.reduce((all, item) => {
        if (!item.seen) all += 1;
        return all;
      }, 0);
    }
    return (
      <ErrorBoundary>
        <Cornerstone />
        <ToastContainer />
        <NavBar
          user={this.state.user}
          openGearMenu={this.handleMngMenu}
          openInfoMenu={this.handleInfoMenu}
          openUser={this.handleUserProfileMenu}
          onReports={this.handleReportsClick}
          logout={this.onLogout}
          onSearchViewClick={this.switchSearhView}
          onSwitchView={this.switchView}
          viewType={this.state.viewType}
          notificationWarning={noOfUnseen}
          pid={this.state.pid}
          path={this.props.location.pathname}
        />
        {showReportsMenu && (
          <SelectModalMenu
            list={reportsList}
            onClick={this.handleReportSelect}
          />
        )}
        {this.state.openMng && (
          <Management
            closeMenu={this.closeMenu}
            updateProgress={this.updateProgress}
            admin={this.state.admin}
            getProjectAdded={this.getProjectAdded}
            pid={this.state.pid}
            clearAllTreeData={this.clearAllTreeData}
            clearTreeExpand={this.clearTreeExpand}
            openProject={this.openProject}
          />
        )}
        {this.state.openInfo && (
          <InfoMenu
            closeMenu={this.closeMenu}
            user={this.state.user}
            notifications={notifications}
            notificationWarning={noOfUnseen}
          />
        )}
        {this.state.openUser && (
          <UserMenu
            closeMenu={this.closeMenu}
            user={this.state.user}
            admin={this.state.admin}
          />
        )}
        {showWarning && (
          <WarningModal
            onOK={this.closeWarning}
            title={title}
            message={message}
          />
        )}
        {showConfirmation && (
          <ConfirmationModal
            title={title}
            button={"Get Report"}
            message={message}
            onSubmit={this.displayWaterfall}
            onCancel={this.closeWarning}
          />
        )}
        {this.state.reportsCompArr}
        {this.state.minReportsArr}

        {!this.state.authenticated && mode !== "lite" && (
          <Route path="/login" render={() => Keycloak(JSON.parse(sessionStorage.getItem("keycloakJson")))?.login()} />
        )}
        {this.state.authenticated && mode !== "lite" && (
          <div style={{ display: "inline", width: "100%", height: "100%" }}>
            <Sidebar
              type={this.state.viewType}
              progressUpdated={progressUpdated}
              getPidUpdate={this.getPidUpdate}
              pid={this.state.pid}
              clearTreeExpand={this.clearTreeExpand}
              projectAdded={this.state.projectAdded}
              openClose={this.state.leftMenuState}
            >
              <Switch className="splitted-mainview">
                <Route path="/logout" render={(props) => (
                  <Logout logout={this.onLogout} />
                )} />
                <ProtectedRoute
                  path="/display"
                  render={(props) => (
                    <DisplayView
                      {...props}
                      updateProgress={this.updateProgress}
                      pid={this.state.pid}
                      updateTreeDataOnSave={this.updateTreeDataOnSave}
                      keycloak={this.state.keycloak}
                      onSwitchView={this.switchView}
                      closeLeftMenu={this.closeLeftMenu}
                      savedData={this.state.savedData}
                      saveData={(data) => { this.state.savedData = data }}
                      displayNextStudy={this.displayNextStudy}
                    />
                  )}
                />
                <ProtectedRoute
                  path="/list/:pid?"
                  render={(props) => (
                    <SearchView
                      {...props}
                      clearTreeExpand={this.clearTreeExpand}
                      updateProgress={this.updateProgress}
                      progressUpdated={progressUpdated}
                      expandLevel={this.state.expandLevel}
                      getTreeExpandSingle={this.getTreeExpandSingle}
                      getTreeExpandAll={this.getTreeExpandAll}
                      treeExpand={treeExpand}
                      getExpandLevel={this.getExpandLevel}
                      closeBeforeDelete={this.closeBeforeDelete}
                      // expandLoading={expandLoading}
                      // updateExpandedLevelNums={this.updateExpandedLevelNums}
                      onShrink={this.handleShrink}
                      handleCloseAll={this.handleCloseAll}
                      treeData={this.state.treeData}
                      getTreeData={this.getTreeData}
                      clearTreeData={this.clearTreeData}
                      updateTreeDataOnSave={this.updateTreeDataOnSave}
                      closeAllCounter={this.state.closeAll}
                      pid={this.state.pid}
                      admin={this.state.admin}
                      collapseSubjects={this.collapseSubjects}
                      update={this.state.update}
                      forceUpdatePage={() => this.setState(state => ({ update: state.update + 1 }))}
                    />
                  )}
                />
                <ProtectedRoute path="/anotate" component={AnotateView} />
                <ProtectedRoute
                  path="/progress/:wid?"
                  component={ProgressView}
                />
                <ProtectedRoute
                  path="/flex/:pid?"
                  render={(props) => (
                    <FlexView {...props} pid={this.state.pid} />
                  )}
                />
                <ProtectedRoute
                  path="/search/:pid?"
                  render={(props) => (
                    <AnnotationSearch
                      {...props}
                      update={this.state.update}
                      pid={this.state.pid}
                      searchQuery={this.state.searchQuery}
                      setQuery={(query) =>
                        this.setState({ searchQuery: query })
                      }
                      completeLoading={() => this.setState({ loading: false, freeze: 'auto' })}
                      loading={this.state.loading}
                      teachingLoading={this.state.teachingLoading}
                      forceUpdatePage={() => this.setState(state => ({ update: state.update + 1 }))}
                      getPidUpdate={this.getPidUpdate}
                      projectToRole={this.state.projectToRole}
                      admin={this.state.admin}
                      username={this.state.username}
                    />
                  )}
                />
                <ProtectedRoute
                  path="/worklist/:wid?"
                  render={(props) => (
                    <Worklist
                      {...props}
                      getWorklistPatient={this.getWorklistPatient}
                      reports={this.state.reportsCompArr}
                    />
                  )}
                />
                {/* component={Worklist} /> */}
                <Route path="/tools" />
                <Route path="/edit" />
                <Route path="/not-found" component={NotFound} />
                {mode !== "teaching" && (
                  <ProtectedRoute
                    from="/"
                    exact
                    to="/list"
                    render={(props) => (
                      <SearchView
                        {...props}
                        clearTreeExpand={this.clearTreeExpand}
                        updateProgress={this.updateProgress}
                        progressUpdated={progressUpdated}
                        expandLevel={this.state.expandLevel}
                        getTreeExpandSingle={this.getTreeExpandSingle}
                        closeBeforeDelete={this.closeBeforeDelete}
                        getTreeExpandAll={this.getTreeExpandAll}
                        treeExpand={treeExpand}
                        getExpandLevel={this.getExpandLevel}
                        // expandLoading={expandLoading}
                        // updateExpandedLevelNums={this.updateExpandedLevelNums}
                        onShrink={this.handleShrink}
                        handleCloseAll={this.handleCloseAll}
                        treeData={this.state.treeData}
                        getTreeData={this.getTreeData}
                        clearTreeData={this.clearTreeData}
                        updateTreeDataOnSave={this.updateTreeDataOnSave}
                        closeAllCounter={this.state.closeAll}
                        pid={this.state.pid}
                        admin={this.state.admin}
                        collapseSubjects={this.collapseSubjects}
                        update={this.state.update}
                      />
                    )}
                  />
                )}
                {mode === "teaching" && (
                  <Redirect
                    from="/"
                    to="/search"

                  />
                )}

                <Redirect to="/not-found" />
              </Switch>
              {/* {this.props.activePort === 0 ? <AnnotationsList /> : null} */}
            </Sidebar>
          </div>
        )}
        {this.state.authenticated && mode === "lite" && (
          <Sidebar
            type={this.state.viewType}
            progressUpdated={progressUpdated}
            getPidUpdate={this.getPidUpdate}
            pid={this.state.pid}
            clearTreeExpand={this.clearTreeExpand}
            projectAdded={this.state.projectAdded}
            getWorklistPatient={this.getWorklistPatient}
          >
            <Switch>
              <Route path="/logout" component={Logout} />
              <ProtectedRoute
                path="/display"
                render={(props) => (
                  <DisplayView
                    {...props}
                    updateProgress={this.updateProgress}
                    pid={this.state.pid}
                    updateTreeDataOnSave={this.updateTreeDataOnSave}
                    keycloak={this.state.keycloak}
                    onSwitchView={this.switchView}
                    closeLeftMenu={this.closeLeftMenu}
                    savedData={this.state.savedData}
                    saveData={(data) => { this.state.savedData = data }}
                    displayNextStudy={this.displayNextStudy}
                  />
                )}
              />
              <Route path="/not-found" component={NotFound} />
              <ProtectedRoute
                path="/worklist/:wid?"
                render={(props) => (
                  <Worklist
                    {...props}
                    getWorklistPatient={this.getWorklistPatient}
                    reports={this.state.reportsCompArr}
                    setSeriesCallSent={() => {
                      this.seriesCallSent = null
                    }
                    }
                  />
                )}
              />
              <ProtectedRoute path="/progress/:wid?" component={ProgressView} />
              <ProtectedRoute
                path="/flex/:pid?"
                render={(props) => <FlexView {...props} pid={this.state.pid} />}
              />
              <ProtectedRoute
                path="/search/:pid?"
                render={(props) => (
                  <AnnotationSearch
                    {...props}
                    pid={this.state.pid}
                    update={this.state.update}
                    searchQuery={this.state.searchQuery}
                    setQuery={(query) => this.setState({ searchQuery: query })}
                    completeLoading={() => this.setState({ loading: false, freeze: 'auto' })}
                    loading={this.state.loading}
                    forceUpdatePage={() => this.setState(state => ({ update: state.update + 1 }))}
                    getPidUpdate={this.getPidUpdate}
                    projectToRole={this.state.projectToRole}
                    admin={this.state.admin}
                    username={this.state.username}
                  />
                )}
              />
              <ProtectedRoute
                path="/"
                render={(props) => (
                  <SearchView
                    {...props}
                    clearTreeExpand={this.clearTreeExpand}
                    updateProgress={this.updateProgress}
                    progressUpdated={progressUpdated}
                    expandLevel={this.state.expandLevel}
                    getTreeExpandSingle={this.getTreeExpandSingle}
                    closeBeforeDelete={this.closeBeforeDelete}
                    getTreeExpandAll={this.getTreeExpandAll}
                    treeExpand={treeExpand}
                    getExpandLevel={this.getExpandLevel}
                    pid={this.state.pid}
                    // expandLoading={expandLoading}
                    // updateExpandedLevelNums={this.updateExpandedLevelNums}
                    onShrink={this.handleShrink}
                    handleCloseAll={this.handleCloseAll}
                    // treeData={this.state.treeData}
                    getTreeData={this.getTreeData}
                    closeAllCounter={this.state.closeAll}
                    admin={this.state.admin}
                    collapseSubjects={this.collapseSubjects}
                    update={this.state.update}
                  />
                )}
              />
              <Redirect to="/not-found" />
            </Switch>
          </Sidebar>
        )}
        {/* {this.props.showGridFullAlert && <MaxViewAlert />} */}
        {/* {this.props.selection && (
          <ManagementItemModal selection={this.props.selection} />
        )} */}
        {this.state.showSeries && this.state.openSeriesData.series.length > 0 && (
          <SelectSeriesModal
            seriesPassed={[this.state.openSeriesData.series]}
            onCancel={() => {
              this.setState({ showSeries: false });
              this.seriesCallSent = null;
            }}
            studyName={this.state.openSeriesData.studyName}
            worklistID={this.state.openSeriesData.worklistID}
          />
        )}
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    showGridFullAlert,
    showProjectModal,
    loading,
    activePort,
    imageID,
    openSeries,
    selectedProject,
    selectedPatients,
    projectMap,
    lastEventId,
    notificationAction,
    isSegUploaded,
    seriesData
  } = state.annotationsListReducer;
  return {
    showGridFullAlert,
    showProjectModal,
    loading,
    activePort,
    imageID,
    openSeries,
    selectedProject,
    selectedPatients,
    projectMap,
    lastEventId,
    notificationAction,
    isSegUploaded,
    seriesData,
    selection: state.managementReducer.selection,
  };
};
export default withRouter(connect(mapStateToProps)(App));
